import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { SearchWidget } from '@x-pubsrv/mlb-search';
import { getContextualUrl } from '../scripts/utils';

// import HeaderContext from '../HeaderContext';
import LoginButton from './LoginButton';
import MenuButton from './MenuButton';
import QuickNavBar from './QuickNavBar';
import RevenueNavBar from './RevenueNavBar';
import Logo from './Logo';
import { transformNavVariables, filterTopNavs } from '../scripts/dataModel';
var NavTop = function NavTop(_ref) {
  var closeMenu = _ref.closeMenu,
    clubId = _ref.clubId,
    clubProps = _ref.clubProps,
    _ref$headerNavigation = _ref.headerNavigationTextColor,
    headerNavigationTextColor = _ref$headerNavigation === void 0 ? '#ffffff' : _ref$headerNavigation,
    _ref$headerNavigation2 = _ref.headerNavigationTextColorHover,
    headerNavigationTextColorHover = _ref$headerNavigation2 === void 0 ? null : _ref$headerNavigation2,
    isClub = _ref.isClub,
    isFieldPassOpen = _ref.isFieldPassOpen,
    isLoggedIn = _ref.isLoggedIn,
    locale = _ref.locale,
    menuToggle = _ref.menuToggle,
    navItems = _ref.navItems,
    navSideOpen = _ref.navSideOpen,
    navVariables = _ref.navVariables,
    onLogout = _ref.onLogout,
    setFieldPassOpen = _ref.setFieldPassOpen,
    teamNameDisplay = _ref.teamNameDisplay,
    teamNameSlug = _ref.teamNameSlug,
    useFieldPass = _ref.useFieldPass,
    useInlineLogout = _ref.useInlineLogout;
  var primaryLogo = clubProps.primaryLogo,
    urlLogo = clubProps.urlLogo,
    logoUrl = clubProps.logoUrl,
    sponsorLogo = clubProps.sponsorLogo,
    tagline = clubProps.tagline,
    sponsorUrl = clubProps.sponsorUrl;
  var _filterTopNavs = filterTopNavs(navItems),
    quickNavBarItems = _filterTopNavs.quickNavBarItems,
    revenueNavBarItems = _filterTopNavs.revenueNavBarItems,
    revenueHasMobileItems = _filterTopNavs.revenueHasMobileItems;
  var _transformNavVariable = transformNavVariables(navVariables),
    sitesearch = _transformNavVariable.sitesearch,
    ismlbtvnav = _transformNavVariable.ismlbtvnav,
    siteaccount = _transformNavVariable.siteaccount;
  var _useState = useState(isLoggedIn),
    _useState2 = _slicedToArray(_useState, 2),
    isLoggedInLocally = _useState2[0],
    setIsLoggedInLocally = _useState2[1];
  var isBrowser = typeof window !== 'undefined';
  var topNavContainerRef = useRef(null);
  var homePageUrl = getContextualUrl('/', teamNameSlug, locale);
  var hasQuickNavItems = quickNavBarItems.length !== 0;
  useEffect(function () {
    // This allows dropdowns to display on the client
    topNavContainerRef.current.classList.add('header__nav-top__nav-container--initialized');
  }, [isBrowser]);
  useEffect(function () {
    setIsLoggedInLocally(isLoggedIn);
    if (!isLoggedIn && !useFieldPass) {
      checkLoginState();
    }
  }, [checkLoginState, useFieldPass, isLoggedIn]);
  var checkLoginState = useCallback(function () {
    if (isBrowser && window.mlbOkta) {
      window.mlbOkta.isLoggedIn().then(function () {
        setIsLoggedInLocally(true);
      })["catch"](function () {
        setIsLoggedInLocally(false);
      });
    } else {
      setIsLoggedInLocally(false);
    }
  }, [isBrowser]);
  return /*#__PURE__*/React.createElement("div", {
    className: "header__nav-top",
    "aria-label": "Top Navigation"
  }, /*#__PURE__*/React.createElement(MenuButton, {
    click: menuToggle,
    locale: locale,
    navSideOpen: navSideOpen
  }), /*#__PURE__*/React.createElement(Logo, {
    imgSrc: primaryLogo,
    alt: teamNameDisplay,
    className: 'header__nav-top__logo ' + "header__nav-top__logo--".concat(clubId),
    url: logoUrl || homePageUrl
  }), (tagline || sponsorLogo || isClub || !isClub && urlLogo) && /*#__PURE__*/React.createElement("div", {
    className: "header__nav-top__secondary-logos"
  }, /*#__PURE__*/React.createElement(Logo, {
    imgSrc: tagline,
    alt: "",
    className: 'header__nav-top__tagline ' + (sponsorLogo ? 'header__nav-top__tagline--with-sponsor ' : 'header__nav-top__tagline--no-sponsor ') + "header__nav-top__tagline--".concat(clubId),
    role: "presentation"
  }), /*#__PURE__*/React.createElement("div", {
    className: 'header__nav-top__sponsor-url-logos' + (!sponsorLogo ? ' header__nav-top__sponsor-url-logos--no-sponsor' : '')
  }, /*#__PURE__*/React.createElement(Logo, {
    imgSrc: sponsorLogo,
    alt: "Link to sponsor",
    className: 'header__nav-top__sponsor-logo ' + (tagline ? '' : 'header__nav-top__sponsor-logo--no-tagline'),
    url: sponsorUrl,
    newWindow: true
  }), /*#__PURE__*/React.createElement(Logo, {
    imgSrc: urlLogo,
    alt: "".concat(teamNameDisplay, " URL logo"),
    className: 'header__nav-top__url-logo ' + (sponsorLogo ? 'header__nav-top__url-logo--with-sponsor ' : 'header__nav-top__url-logo--no-sponsor ') + (tagline ? 'header__nav-top__url-logo--with-tagline ' : 'header__nav-top__url-logo--no-tagline '),
    url: homePageUrl
  }))), /*#__PURE__*/React.createElement("div", {
    ref: topNavContainerRef,
    className: "header__nav-top__nav-container"
  }, hasQuickNavItems && /*#__PURE__*/React.createElement(QuickNavBar, {
    quickNavBarItems: quickNavBarItems,
    isLoggedIn: isLoggedInLocally,
    closeMenu: closeMenu,
    isClub: isClub,
    forceShowRevenue: revenueHasMobileItems
  }), /*#__PURE__*/React.createElement(RevenueNavBar, {
    revenueNavBarItems: revenueNavBarItems,
    closeMenu: closeMenu,
    isClub: isClub
  })), sitesearch && /*#__PURE__*/React.createElement(SearchWidget, {
    lang: locale,
    iconColor: headerNavigationTextColor,
    iconColorHover: headerNavigationTextColorHover
  }), siteaccount && /*#__PURE__*/React.createElement(LoginButton, {
    clubId: clubId,
    isClub: isClub,
    isFieldPassOpen: isFieldPassOpen,
    isLoggedIn: isLoggedInLocally,
    isMlbtvNav: ismlbtvnav,
    locale: locale,
    onLogout: onLogout,
    setFieldPassOpen: setFieldPassOpen,
    useFieldPass: useFieldPass,
    useInlineLogout: useInlineLogout
  }));
};
NavTop.propTypes = {
  closeMenu: PropTypes.func.isRequired,
  clubId: PropTypes.string,
  clubProps: PropTypes.shape({
    primaryLogo: PropTypes.string,
    urlLogo: PropTypes.string,
    logoUrl: PropTypes.string,
    sponsorLogo: PropTypes.string,
    tagline: PropTypes.string,
    sponsorUrl: PropTypes.string
  }),
  isClub: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  isFieldPassOpen: PropTypes.bool,
  locale: PropTypes.string,
  menuToggle: PropTypes.func.isRequired,
  navItems: PropTypes.instanceOf(Array).isRequired,
  navSideOpen: PropTypes.bool.isRequired,
  navVariables: PropTypes.instanceOf(Array),
  onLogout: PropTypes.func,
  teamNameDisplay: PropTypes.string,
  teamNameSlug: PropTypes.string,
  headerNavigationTextColor: PropTypes.string,
  headerNavigationTextColorHover: PropTypes.string,
  setFieldPassOpen: PropTypes.func,
  useFieldPass: PropTypes.bool,
  useInlineLogout: PropTypes.bool
};
export default NavTop;